module.exports = __webpack_public_path__ + "static/media/door_open3_icon.62a52306.png";